import { render, staticRenderFns } from "./RegionLock.vue?vue&type=template&id=639fbc93&"
import script from "./RegionLock.vue?vue&type=script&lang=js&"
export * from "./RegionLock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports